import React from "react";
import PropTypes from "prop-types";
import {
  ChartValueAxis,
  ChartValueAxisItem,
} from "@progress/kendo-react-charts";

/**
 * ChartValueAxisComponent
 * @class
 * @property {object} valueAxisItemProps - Props of module ChartValueAxisItem
 */

/**
 * ChartValueAxis
 * @module
 */

/**
 * ChartValueAxisItem
 * @module
 * @property {string} title - Title
 * @property {string} name - Name
 */

const ChartValueAxisComponent = (props) => {
  const { valueAxisItemProps } = props;
  return (
    <ChartValueAxis>
      {valueAxisItemProps.map((item, idx) => (
        <ChartValueAxisItem key={idx} title={item.title} name={item.name} />
      ))}
    </ChartValueAxis>
  );
};

ChartValueAxisComponent.propTypes = {
  valueAxisItemProps: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.shape({
        text: PropTypes.string,
      }),
      name: PropTypes.string,
    })
  ),
};

export default ChartValueAxisComponent;
